/* eslint-disable prefer-rest-params */
define(['jQuery', 'toolkit/b-layer/b-layer', 'toolkit/b-panel/b-panel'], (
    $,
    BLayer /* , BPanel*/,
) => {
    return BLayer.extend('confirm-dialog', {
        inner: true,
        renderMode: 'replace',
        canHide: true,

        init() {
            this.templateBlock = 'b-layer';

            BLayer.fn.init.apply(this, arguments);
        },

        onClose() {
            this.emit('done');
        },

        onApprove() {
            this.emit('done');
        },

        onRender() {
            'use strict';
        },

        getData() {
            let data = BLayer.fn.getData.apply(this, arguments);

            data = $.extend(
                {},
                {
                    block: 'b-panel',
                    mods: ['alert-dialog'],
                    params: {
                        mods: ['popup', 'service'],

                        header: {
                            title: data.header || 'Уведомление',
                        },
                        close: true,
                        view: 'alert-dialog',
                        content: {
                            mods: [],
                            message: data.message,
                            htmlMessage: data.htmlMessage,
                        },
                        footer: {
                            btn: [
                                {
                                    mods: ['main'],
                                    name: 'approve',
                                    text: data.ok || 'Подтвердить',
                                },
                            ],
                        },
                    },
                },
            );

            return data;
        },
    });
});
